export const apiPath = '/v2/controls';
const actionType = 'CONTROLS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
